import { network } from 'services/network';

import { QueryParams } from 'api/queries/getBaselineVsActual.query';

export const ENDPOINT = 'api/bo/getBaselineVsActual';

export const getBaselineVsActual = (params: QueryParams) => {
    return network.post(ENDPOINT, params).then((response) => response.data);
};
